import request from '@/utils/request'

const prefix = '/django_rest/hr-dashboard'

export default {
  getJobCountInfo (params) {
    return request.get(`${prefix}/job-count/`, { params })
  },
  getApplicationCountInfo (params) {
    return request.get(`${prefix}/application-count/`, { params })
  },
  getApplicationDataInfo (params) {
    return request.get(`${prefix}/application-data/`, { params })
  },
  getChannelCountInfo (params) {
    return request.get(`${prefix}/channel-count/`, { params })
  },
  getInterviewInfo (params) {
    return request.get(`${prefix}/interview/`, { params })
  },
  getPersonalizedInfo (params) {
    return request.get(`${prefix}/personalized/`, { params })
  },
  savePersonalizedInfo (params) {
    return request.post(`${prefix}/personalized/`, params)
  }
}
